var _circle, _circle2, _circle3, _circle4, _circle5, _path, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 186,
    viewBox: "0 0 330 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 55,
    r: 55,
    fill: "#FFDB65"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 55,
    r: 55,
    fill: "#FF924D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 55,
    r: 55,
    fill: "#FF3A68"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 55,
    r: 55,
    fill: "#CA0099"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#2A24C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.04 175V148.84H138.8V145.4H161.2V148.84H151.96V175H148.04ZM166.216 175V145.4H170.136V158.24H184.256V145.4H188.176V175H184.256V161.76H170.136V175H166.216Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 157.5,
    x2: 126,
    y2: 157.5,
    stroke: "black",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 207,
    y1: 158.5,
    x2: 323,
    y2: 158.5,
    stroke: "black",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.961fefed3e0c7c17f6929a6d6d74e30b.svg";
export { ForwardRef as ReactComponent };